

import { serialize, jumpByIframe, jumpInHuya, jump, Loading } from './utils/utils';
import getAppUrl from './utils/getAppUrl';
import getDownloadUrl from './utils/getDownloadUrl';
import browser from './utils/device';
import visibility from './utils/visibility';
import wechatApi from './utils/wechatApi';

let appTimer = null;
let loading = Loading(); // 加载动画
let wechatTimer = null;
let isPageHidden = false;

function openApp(option) {
    let appUrl = getAppUrl(option);
    let ckey = option.ckey || 'CK1373400281356', // 应用宝下载安卓APP时用来区分渠道
        downloadUrl = option.downloadUrl ? decodeURI(option.downloadUrl) : getDownloadUrl(option),
        beforeOpen = option.beforeOpen || function () { },
        isForceSchemaLink = option.isForceSchemaLink || false,
        isAutoDownload = option.isAutoDownload === false ? false : true,
        wechatDebugMode = option.wechatDebugMode || false,
        cancelTime = option.cancelTime || 4000,
        openFailCallback = option.openFailCallback || function () { },
        wechatOpenFailCallback = option.wechatOpenFailCallback || function () {
            if (isAutoDownload) {
                location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.duowan.kiwi&ckey=' + ckey + '&' + (browser.isIos ? 'ios' : 'android') + '_schema=' + encodeURIComponent(appUrl.schemaLink);
            }
        },
        wechatOpenCancelCallback = option.wechatOpenCancelCallback || function () { },

        openCancelCallback = function () {
            // 这里的定时器，是延后执行函数，等到hidden 结果出来后再执行;
            // 这里有副作用，如果弹出跳转确认弹窗，cancelTime 内不操作，就执行。
            // 另外一种情况是，如果跳转到APP，cancelTime 内返回页面，同样也会执行
            clearTimeout(wechatTimer)
            wechatTimer = setTimeout(() => {
                if (!isPageHidden) {
                    wechatOpenCancelCallback()
                    clearTimeout(wechatTimer)
                }
            }, cancelTime)
        };




    loading.show();

    if (browser.isWx && wechatApi.versionGreaterThan("6.5.16") && !browser.isWxWork) {
        console.log('微信环境（非企业微信）')
        loading.hide(); // 微信API，还有可能是直接取消

        wechatApi.openApp({
            schema: appUrl.schemaLink,
            openFailCallback: wechatOpenFailCallback,
            openCancelCallback,
            wechatDebugMode,
        });
    } else if (browser.isHuyaApp) {
        console.log('虎牙环境')
        console.log('跳转链接', appUrl.appLink)
        jumpInHuya(appUrl.appLink)
    } else {

        beforeOpen();

        appTimer = setTimeout(() => {
            loading.hide();
            openFailCallback();
            if (isAutoDownload) {
                console.log('跳转链接', downloadUrl)
                jump(downloadUrl);
            }
        }, 4000);

        if (browser.isAndroid) {
            if (browser.isAnChrome) {
                console.log('安卓chrome')
                console.log('跳转链接', appUrl.schemaLink)
                jump(appUrl.schemaLink);
            } else {
                console.log('安卓环境')
                console.log('跳转链接', appUrl.schemaLink)
                jumpByIframe(appUrl.schemaLink);
            }
        } else {
            let targetUrl = '';
            if (browser.isUc) {
                console.log('ios的uc环境')
                targetUrl = appUrl.universalLink;
            } else if (isForceSchemaLink || !browser.iosVersionlargeThan8 || browser.isQQ || browser.isWeibo || browser.isQQBrowser || browser.isIosChrome) {
                console.log('强制schema环境')
                targetUrl = appUrl.schemaLink;
            } else {
                console.log('其他ios环境')
                targetUrl = appUrl.universalLink;
            }
            console.log('跳转链接', targetUrl)
            jump(targetUrl);
        }
    }
}

visibility.change((isHidden) => {
    if (isHidden) {
        loading.hide();
        clearTimeout(appTimer);
        isPageHidden = true
    } else {
        isPageHidden = false
    }
})

export default openApp;





// WEBPACK FOOTER //
// ./src/main.js